import { useEffect, useCallback, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { API } from '../config';

const SESSION_KEY = 'hexopdf_session_id';

function getSessionId() {
  let sid = sessionStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

function getUserId() {
  try {
    const token = localStorage.getItem('hexopdf_token');
    if (!token) return '';
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.user_id || '';
  } catch { return ''; }
}

function sendBeacon(url, data) {
  const body = JSON.stringify(data);
  if (navigator.sendBeacon) {
    navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
  } else {
    fetch(url, { method: 'POST', body, headers: { 'Content-Type': 'application/json' }, keepalive: true }).catch(() => {});
  }
}

export function useTracking() {
  const location = useLocation();
  const lastPath = useRef('');

  // Track page views on route change
  useEffect(() => {
    const path = location.pathname;
    if (path === lastPath.current) return;
    lastPath.current = path;

    sendBeacon(`${API}/track/pageview`, {
      path,
      referer: document.referrer,
      session_id: getSessionId(),
      user_id: getUserId(),
    });
  }, [location.pathname]);

  // Track custom events
  const trackEvent = useCallback((event, data = {}) => {
    sendBeacon(`${API}/track/event`, {
      event,
      page: window.location.pathname,
      data,
      session_id: getSessionId(),
      user_id: getUserId(),
    });
  }, []);

  return { trackEvent };
}
